export const LOADING = 'search.LOADING';
export const LOADED = 'search.LOADED';